<template>
<span class="d-flex">
	<menu-icon
		name="station_alerts"
		color="currentColor"
		edge-size="18"
		class="me-2"
	/>
	Сповіщення; клас:&nbsp;<span class="fw-bolder">{{ classTitle }}</span>
</span>
<p class="paragraph-indent">
	Тип: 
	<span
		:class="{
			'text-danger': typeTransition === 'activation',
			'text-success': typeTransition === 'return'
		}"
	>
		{{ typeTitle }}
	</span>
</p>
<p class="paragraph-indent">
	Значення:
	<span
		:class="{
			'text-primary': [
				alertSchema.value.allowed.shortCircuit.key,
				alertSchema.value.allowed.noBreakdown.key
			].includes($props[alertSchema.value.key]),
			'text-info': $props[alertSchema.value.key] == alertSchema.value.allowed.circuitConnected.key,
			'text-danger': [
				alertSchema.value.allowed.circuitDisconnected.key,
				$props[alertSchema.value.key] == alertSchema.value.allowed.lowThreshold.key,
				$props[alertSchema.value.key] == alertSchema.value.allowed.hiThreshold.key
			].includes($props[alertSchema.value.key]),
			'text-purple': $props[alertSchema.value.key] == alertSchema.value.allowed.normalStateReturn.key,
		}"
	>
		{{ valueTitle }}
	</span>
</p>
<p v-if="this.$props[alertSchema.nominal.key]" class="paragraph-indent">
	Номінал: {{ this.$props[alertSchema.nominal.key] }}
</p>
<p class="paragraph-indent">
	Лічильник: {{ this.$props[alertSchema.counter.key] }}
</p>
</template>



<script>
import MenuIcon from '@/components/Icons/MenuIcon.vue'
import { capitalizeFirstLetter } from '@/helpers.js'
import { alertSchema } from '@/composables/alerts.js'


export default {
	components: {
		MenuIcon,
	},
	
	props: {
		[alertSchema.time.key]: {
			type: Date,
			require: true,
		},
		[alertSchema.class.key]: {
			type: String,
			require: true,
		},
		[alertSchema.counter.key]: {
			type: Number,
			require: true,
		},
		[alertSchema.stationId.key]: {
			type: String,
			require: true,
		},
		[alertSchema.type.key]: {
			type: String,
			require: true,
		},
		[alertSchema.value.key]: {
			type: String,
			require: true,
		},
		[alertSchema.nominal.key]: {
			type: String,
			require: false,
		},
	},

	setup() {
		return {
			capitalizeFirstLetter,
			alertSchema,
		}
	},

	methods: {},

	computed: {
		classTitle() {
			return this.alertSchema.class
				.findClass(this.$props[alertSchema.class.key])
				.title
		},

		typeTitle() {
			return this.alertSchema.type
				.findType(this.$props[alertSchema.type.key])
				.title
		},

		typeTransition() {
			return this.alertSchema.type
				.findType(this.$props[alertSchema.type.key])
				.transition
		},

		valueTitle() {
			return this.alertSchema.value
				.findValue(this.$props[alertSchema.value.key])
				.title
		},
	},
}
</script>